import './ratingsScorecard.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RatingsScorecard/index.js